import { mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import {
  formatCoverType,
  includesContents,
  includesBuildings,
} from "@/common/answers";
import { PRODUCT } from "@/constants/common.constants";
import numeral from "numeral";

export default {
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["getQuestionCoverType", "productId"]),
    isContentsCover() {
      return includesContents(this.getQuestionCoverType);
    },
    isBuildingsCover() {
      return includesBuildings(this.getQuestionCoverType);
    },
    coverType() {
      return formatCoverType(this.getQuestionCoverType?.Value);
    },
    isContentsOnlyProduct() {
      return [PRODUCT.Tenants_Contents].includes(
        numeral(this.productId).value()
      );
    },
  },
};
